import React, { memo, useRef, forwardRef } from 'react';
import { Text, ActivityIndicator, View, StyleSheet } from 'react-native';
import TouchableOpacity from './form/touchable_opacity';
import { COLOR, FONT, FONT_FAMILY, FONT_SIZE } from '../../constants/styles';

const CTAButton = forwardRef((props, ref) => {
  const { label, onPress, style, fontStyle, disabled, renderSpinner, autoFocus } = props;
  let styleType = props.styleType;
  if (styleType === 1 || styleType === 'primary' || styleType === 'main') styleType = 'main';
  if (styleType === 2 || styleType === 'secondary' || styleType === 'cancel')
    styleType = 'secondary';

  const classNames = disabled ? '' : styleType === 'secondary' ? 'op-secondary-btn' : 'op-main-btn';

  const buttonRef = useRef(null);

  React.useImperativeHandle(ref, () => ({
    setFocus: () => {
      buttonRef.current?.focus();
    },
  }));

  return (
    <TouchableOpacity
      ref={buttonRef}
      classNames={classNames}
      containerStyle={props.containerStyle}
      style={[
        styles.main,
        styleType === 'secondary' ? styles.secondary : null,
        style,
        { opacity: disabled ? 0.5 : 1 },
      ]}
      onPress={onPress}
      disabled={!!disabled}
      testID={props.testID}
      autoFocus={autoFocus === true}
    >
      <Text
        style={[
          styles.mainText,
          styleType === 'secondary' ? styles.secondaryText : null,
          fontStyle,
        ]}
      >
        {label}
      </Text>
      {!!renderSpinner && (
        <View style={{ marginLeft: 10 }}>
          <ActivityIndicator animating={true} size="small" color={'white'} />
        </View>
      )}
    </TouchableOpacity>
  );
});

const styles = StyleSheet.create({
  mainText: {
    ...FONT.semibold,
    fontSize: FONT_SIZE.large,
    color: 'white',
    textAlign: 'center',
    letterSpacing: 1,
  },
  secondaryText: {
    color: COLOR.text,
  },
  main: {
    paddingVertical: 15,
    paddingHorizontal: 10,
    height: 55,
    minWidth: 118,
    backgroundColor: COLOR.button,
    borderRadius: 5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  secondary: {
    backgroundColor: '#f1f1f1',
    borderWidth: 2,
    borderColor: '#777777',
  },
});

export default memo(CTAButton);
